module.exports = __webpack_public_path__ + "img/img_avatar.adde316a.png";